export default {
  manage_cameraManagement_editCamera_title: "Editar Cámara",
  manage_cameraManagement_editCamera_cameraUpdated: "La cámara fue actualizada exitosamente",
  manage_cameraManagement_editCamera_errorMessage:
    "Se ha producido un error al actualizar la cámara",
  manage_cameraManagement_editCamera_label: "Etiqueta"
};
